import { defaultLanguage } from '../constants';

export class LanguageInfo {
  constructor(item = {}) {
    this.language = item.language || defaultLanguage;
    this.text = item.text;
    this.image = item.image;
    this.countryCode = item.country_code;
  }
}
